import {observer} from "mobx-react";
import {BUTTON_VARIANTS} from "../../../../../../components/inputs/button-variants";
import {Button} from "../../../../../../components/inputs/button/button";
import ProductCaseStore from "../../../stores/product-case-store";
import RmaPageStore from "../../../stores/rma-page-store";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../../../../stores/rms-mixpanel-store";

interface IValidateItemButtonsProps {
    productCaseStore: ProductCaseStore;
    rmaPageStore: RmaPageStore;
}
const ValidateItemButtons : React.FC<IValidateItemButtonsProps> = observer(({productCaseStore, rmaPageStore})=> {
    const scope = 'dashboard-returns-rma-card';
    const { getTranslation } = useDashboardTranslation();

    if(!productCaseStore.isValidationInEditMode){
        return null;
    }

    const onCancelClick = () => {
        rmsMixpanelStore.trackEvent('d&_original_item_more_cancel', { RMAID: rmaPageStore.rmaId });
        productCaseStore.cancelValidation();
    };

    const onSaveClick = () => {
        rmsMixpanelStore.trackEvent('d&_original_item_more_save', { RMAID: rmaPageStore.rmaId });
        rmaPageStore.validateItemsAction(productCaseStore.getValidationRequestModel());
    };
    
    return (
        <div className={'validate-item'}>
            <div className={'validate-item-buttons'}>
                <Button variant={BUTTON_VARIANTS.Default}
                        text={getTranslation('CANCEL', scope)}
                        onClick={onCancelClick}
                />
                <Button variant={BUTTON_VARIANTS.PrimaryAccent}
                        text={getTranslation('SAVE', scope)}
                        onClick={onSaveClick}
                        hasLoader={true}
                        isLoading={rmaPageStore.isValidatingItems}
                />
            </div>
        </div>
    )
});

export default ValidateItemButtons;